/**
 * Compressor - Compresseur master pour le bus principal
 */

import * as Tone from 'tone';

export class Compressor {
    constructor(audioEngine) {
        this.audioEngine = audioEngine;

        // Paramètres par défaut (assez doux pour commencer)
        this.params = {
            threshold: -24,    // dB
            ratio: 4,          // 4:1
            attack: 0.003,     // 3ms
            release: 0.25,     // 250ms
            knee: 10,          // dB
            enabled: true
        };

        this.setupAudio();
    }

    setupAudio() {
        this.compressor = new Tone.Compressor({
            threshold: this.params.threshold,
            ratio: this.params.ratio,
            attack: this.params.attack,
            release: this.params.release,
            knee: this.params.knee
        });

        // Input/Output nodes
        this.input = this.compressor;
        this.output = this.compressor;
    }

    /**
     * Connecte la sortie du compresseur à une destination
     */
    connectTo(destination) {
        this.output.connect(destination);
    }

    // --- Setters ---

    setThreshold(value) {
        this.params.threshold = value;
        this.compressor.threshold.value = value;
    }

    setRatio(value) {
        this.params.ratio = value;
        this.compressor.ratio.value = value;
    }

    setAttack(value) {
        this.params.attack = value;
        this.compressor.attack.value = value;
    }

    setRelease(value) {
        this.params.release = value;
        this.compressor.release.value = value;
    }

    setKnee(value) {
        this.params.knee = value;
        this.compressor.knee.value = value;
    }

    // --- Getters ---

    get threshold() { return this.params.threshold; }
    get ratio() { return this.params.ratio; }
    get attack() { return this.params.attack; }
    get release() { return this.params.release; }
    get knee() { return this.params.knee; }

    /**
     * Retourne la réduction de gain actuelle (pour un VU meter)
     */
    getReduction() {
        return this.compressor.reduction;
    }

    /**
     * Retourne tous les paramètres (pour sauvegarde)
     */
    getParams() {
        return { ...this.params };
    }

    /**
     * Charge des paramètres (depuis sauvegarde)
     */
    setParams(params) {
        if (params.threshold !== undefined) this.setThreshold(params.threshold);
        if (params.ratio !== undefined) this.setRatio(params.ratio);
        if (params.attack !== undefined) this.setAttack(params.attack);
        if (params.release !== undefined) this.setRelease(params.release);
        if (params.knee !== undefined) this.setKnee(params.knee);
    }
}
